import { api } from "api";

export const getDealerInfo = (onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get("/api/dealer")
      .then((res) => {
        dispatch({
          type: "GET_DEALER_INFO_SUCCESS",
          payload: res.data,
        });

        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "GET_DEALER_INFO_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};
